(() => {
  const updateHeader = () => document.querySelectorAll('.header').forEach(header => header.classList.toggle('is-scrolled', window.scrollY > 36));
  updateHeader();
  window.addEventListener('scroll', updateHeader, { passive: true });
  window.addEventListener('pageshow', updateHeader);
  document.addEventListener('shopify:section:load', updateHeader);
  document.addEventListener('keydown', event => {
    if (event.key === 'Escape') document.querySelectorAll('.mobile-menu[open]').forEach(menu => { menu.open = false; menu.querySelector('summary').focus(); });
  });
})();

(() => {
  const prepareRingEnquiries = () => {
    document.querySelectorAll('[data-ring-whatsapp]').forEach(link => {
      const image = link.querySelector('img');
      const name = link.querySelector('figcaption')?.textContent.trim();
      if (!image || !name) return;
      const imageUrl = new URL(image.getAttribute('src'), document.baseURI).href;
      const message = `Hi Lee, I’m interested in the ${name} from your engagement ring gallery. Could you tell me more about this style?\n\nImage: ${imageUrl}`;
      link.href = `https://wa.me/447356013844?text=${encodeURIComponent(message)}`;
    });
  };
  prepareRingEnquiries();
  document.addEventListener('shopify:section:load', prepareRingEnquiries);
})();

// One-time image entrances; content stays visible if motion or scripting is unavailable.
(() => {
  const motion = window.matchMedia('(prefers-reduced-motion: reduce)');
  if (!('IntersectionObserver' in window) || !Element.prototype.animate) return;
  const seen = new WeakSet();
  const active = new Set();
  const hero = '.eng-hero, .hero-media, .campaign-collage, .ear-main-photo, .about-portrait, .gifting-intro';
  const galleries = '.catalog-grid, .eng-grid, .ear-gallery-grid, .bespoke-gallery-grid, .gifting-bracelet-gallery, .home-categories, .bridal-image-cards';
  const skip = '.logo-link, .pdp-thumbnails, dialog, .catalog-alternate, [data-no-reveal]';
  const observer = new IntersectionObserver(entries => {
    entries.filter(entry => entry.isIntersecting).forEach(entry => {
      const image = entry.target;
      observer.unobserve(image);
      if (motion.matches) return;
      const zoom = !!image.closest(hero);
      const group = image.closest(galleries);
      const peers = group ? [...group.querySelectorAll('img')].filter(img => !img.closest(skip)) : [];
      const delay = group ? (Math.max(0, peers.indexOf(image)) % 4) * 110 : 0;
      const animation = image.animate(zoom ? [
        { opacity: 0, scale: '1.035', clipPath: 'inset(1.7%)' },
        { opacity: 1, scale: '1', clipPath: 'inset(0%)' }
      ] : [
        { opacity: 0, translate: '0 16px' },
        { opacity: 1, translate: '0 0' }
      ], { duration: zoom ? 850 : group ? 750 : 800, delay, easing: 'cubic-bezier(.22,1,.36,1)', fill: 'backwards' });
      active.add(animation);
      animation.finished.catch(() => {}).finally(() => active.delete(animation));
    });
  }, { threshold: 0, rootMargin: '0px 0px -24px 0px' });
  const prepare = () => document.querySelectorAll('main img').forEach(image => {
    if (seen.has(image) || image.closest(skip)) return;
    seen.add(image);
    if (!motion.matches) observer.observe(image);
  });
  motion.addEventListener('change', () => {
    if (motion.matches) {
      observer.disconnect();
      active.forEach(animation => animation.cancel());
      active.clear();
    }
  });
  prepare();
  document.addEventListener('shopify:section:load', prepare);
  const main = document.querySelector('main');
  if (main) new MutationObserver(prepare).observe(main, { childList: true, subtree: true });
})();

// Supplier ring sizing: the selected UK size travels with the order and enquiry.
(() => {
  const setup = () => document.querySelectorAll('[data-ring-ordering]').forEach(panel => {
    if (panel.dataset.initialized) return;
    panel.dataset.initialized = 'true';
    const select = panel.querySelector('[data-order-ring-size]');
    const link = panel.querySelector('[data-ring-size-enquiry]');
    const status = panel.querySelector('[role="status"]');
    const update = () => {
      const image = new URL(panel.dataset.ringImage, document.baseURI).href;
      const message = `Hi Lee, I’m interested in ${panel.dataset.ringTitle} in size ${select.value}. Would it be available sooner than 3–6 weeks?\n\nImage: ${image}`;
      link.href = select.value ? `https://wa.me/447356013844?text=${encodeURIComponent(message)}` : 'https://wa.me/447356013844';
      status.textContent = '';
    };
    select.addEventListener('change', update);
    link.addEventListener('click', event => {
      update();
      if (!select.value) {
        event.preventDefault();
        status.textContent = 'Please select your ring size first.';
        select.focus();
        select.reportValidity();
      }
    });
    update();
  });
  setup();
  document.addEventListener('shopify:section:load', setup);
})();

// Load workshop films as they enter view, with a pause control tied to real playback.
(() => {
  const motion = window.matchMedia('(prefers-reduced-motion: reduce)');
  const states = new Map();
  const sync = state => {
    if (state.failed) {
      state.button.textContent = 'Video unavailable';
      state.button.setAttribute('aria-label', 'Video unavailable');
      state.button.disabled = true;
      return;
    }
    const playing = !state.video.paused && !state.video.ended;
    state.button.textContent = playing ? 'Pause video' : 'Play video';
    state.button.setAttribute('aria-label', `${playing ? 'Pause' : 'Play'} video: ${state.video.getAttribute('aria-label') || 'Jewellery film'}`);
  };
  const play = state => {
    if (state.failed) return;
    const attempt = state.video.play();
    if (attempt) attempt.catch(() => { sync(state); });
  };
  const observer = 'IntersectionObserver' in window ? new IntersectionObserver(entries => {
    entries.forEach(entry => {
      const state = states.get(entry.target);
      state.visible = entry.isIntersecting;
      if (state.visible && !motion.matches && !state.userPaused && !document.hidden) play(state);
      else if (!state.visible) state.video.pause();
    });
  }, { threshold: .1 }) : null;
  const prepare = () => document.querySelectorAll('.workshop-film video').forEach(video => {
    if (states.has(video)) return;
    const button = video.closest('.workshop-film').querySelector('.workshop-pause');
    if (!button) return;
    const state = { video, button, visible: false, userPaused: false };
    states.set(video, state);
    video.autoplay = false;
    video.controls = false;
    video.pause();
    button.removeAttribute('onclick');
    button.addEventListener('click', () => {
      if (video.paused) { state.userPaused = false; play(state); }
      else { state.userPaused = true; video.pause(); }
    });
    const showFailure = () => {
      if (state.failed) return;
      state.failed = true;
      const notice = document.createElement('p');
      notice.className = 'workshop-error';
      notice.setAttribute('role', 'status');
      notice.textContent = 'This video couldn’t load. Please refresh the page to try again.';
      video.closest('.workshop-film').append(notice);
      sync(state);
    };
    video.addEventListener('error', showFailure);
    video.querySelectorAll('source').forEach(source => source.addEventListener('error', showFailure));
    if (video.error) showFailure();
    ['play', 'pause', 'ended'].forEach(event => video.addEventListener(event, () => sync(state)));
    sync(state);
    if (observer) observer.observe(video);
  });
  motion.addEventListener('change', () => {
    if (motion.matches) states.forEach(state => state.video.pause());
  });
  document.addEventListener('visibilitychange', () => {
    states.forEach(state => {
      if (document.hidden) state.video.pause();
      else if (state.visible && !state.userPaused && !motion.matches) play(state);
    });
  });
  prepare();
  document.addEventListener('shopify:section:load', prepare);
})();

// Include the selected earring image in the customer’s enquiry.
(() => {
  const prepareEarEnquiries = () => document.querySelectorAll('.ear-gallery-piece').forEach(link => {
    const image = link.querySelector('img');
    const name = link.querySelector('h3')?.textContent.trim();
    if (!image || !name) return;
    const imageUrl = new URL(image.getAttribute('src'), document.baseURI).href;
    link.href = 'https://wa.me/447356013844?text=' + encodeURIComponent(`Hi Lee, I’m interested in the ${name} from your Ear Stack Sourcing gallery. Could you confirm the price and availability?\n\n${imageUrl}`);
  });
  prepareEarEnquiries();
  document.addEventListener('shopify:section:load', prepareEarEnquiries);
})();

// Personal availability enquiries from prepared product descriptions.
document.addEventListener('click', event => {
  const link = event.target.closest('[data-product-availability]');
  if (!link) return;
  const product = link.closest('[data-product-enquiry-title]');
  if (!product) return;
  const ring = product.querySelector('[data-ring-ordering]');
  const size = ring?.querySelector('[data-order-ring-size]');
  if (size && !size.value) {
    event.preventDefault();
    size.focus();
    size.reportValidity();
    return;
  }
  const image = product.dataset.productEnquiryImage;
  const message = `Hi Lee, I’m interested in ${product.dataset.productEnquiryTitle}${size ? ` in size ${size.value}` : ''}. Could we discuss availability for my preferred date?${image ? `\n\nImage: ${new URL(image, document.baseURI).href}` : ''}`;
  link.href = `https://wa.me/447356013844?text=${encodeURIComponent(message)}`;
});

// Accessible, progressively enhanced detail viewer for annotated design sketches.
(() => {
  let dialog, opener;
  document.addEventListener('click', event => {
    const link = event.target.closest('[data-sketch-enlarge]');
    if (!link || event.ctrlKey || event.metaKey || event.shiftKey || event.altKey) return;
    if (!window.HTMLDialogElement) return;
    event.preventDefault();
    if (!dialog) {
      dialog = document.createElement('dialog');
      dialog.className = 'sketch-viewer';
      dialog.setAttribute('aria-labelledby', 'sketch-viewer-title');
      dialog.innerHTML = '<div class="sketch-viewer-bar"><h2 id="sketch-viewer-title"></h2><button type="button" class="sketch-zoom-toggle" aria-pressed="false">Zoom in</button><button type="button" class="sketch-viewer-close" autofocus>Close ×</button></div><div class="sketch-viewer-scroll" tabindex="0" aria-label="Sketch detail; scroll to explore when zoomed"><img alt=""></div>';
      document.body.append(dialog);
      dialog.querySelector('.sketch-viewer-close').addEventListener('click', () => dialog.close());
      dialog.querySelector('.sketch-zoom-toggle').addEventListener('click', event => {
        const zoomed = dialog.classList.toggle('is-zoomed');
        event.currentTarget.setAttribute('aria-pressed', String(zoomed));
        event.currentTarget.textContent = zoomed ? 'Fit to width' : 'Zoom in';
      });
      dialog.addEventListener('close', () => {
        document.documentElement.classList.remove('sketch-viewer-open');
        opener?.focus({ preventScroll: true });
      });
      dialog.addEventListener('click', event => { if (event.target === dialog) dialog.close(); });
    }
    opener = link;
    dialog.classList.remove('is-zoomed');
    const toggle = dialog.querySelector('.sketch-zoom-toggle');
    toggle.setAttribute('aria-pressed', 'false'); toggle.textContent = 'Zoom in';
    dialog.querySelector('h2').textContent = link.dataset.sketchTitle;
    const img = dialog.querySelector('img');
    img.src = link.href; img.alt = link.querySelector('img').alt;
    document.documentElement.classList.add('sketch-viewer-open');
    dialog.showModal();
    dialog.querySelector('.sketch-viewer-scroll').scrollTo(0, 0);
  });
})();

// Close the mobile menu after selecting a destination, including same-page anchors.
document.addEventListener('click', event => {
  const link = event.target.closest('.mobile-menu nav a');
  if (link) link.closest('.mobile-menu').open = false;
});

// Shopify product gallery and price updates. Product forms submit to Shopify.
(() => {
  const setup = () => {
    document.querySelectorAll('[data-live-product]').forEach(product => {
      if (product.dataset.liveReady) return;
      product.dataset.liveReady = 'true';
      const main = product.querySelector('.pdp-main-image img');
      const opener = product.querySelector('.pdp-main-image');
      const dialog = product.nextElementSibling;
      product.querySelectorAll('[data-gallery-image]').forEach(button => button.addEventListener('click', () => {
        if (!main) return;
        main.removeAttribute('srcset'); main.src = button.dataset.galleryImage;
        main.alt = button.querySelector('img').alt;
        product.querySelectorAll('[data-gallery-image]').forEach(b => b.setAttribute('aria-pressed', String(b === button)));
      }));
      if (opener && dialog?.matches('dialog.image-zoom')) {
        opener.addEventListener('click', () => { const enlarged = dialog.querySelector('img'); enlarged.src = main.currentSrc || main.src; enlarged.alt = main.alt; dialog.showModal(); });
        dialog.querySelector('.zoom-close').addEventListener('click', () => dialog.close());
        dialog.addEventListener('click', event => { if (event.target === dialog) dialog.close(); });
        dialog.addEventListener('close', () => opener.focus());
      }
      product.querySelector('[data-live-variant]')?.addEventListener('change', event => {
        const option = event.target.selectedOptions[0];
        product.querySelector('[data-live-price]').textContent = option.dataset.price;
        const button = product.querySelector('[data-live-add]');
        if (button) { button.disabled = option.dataset.available !== 'true'; buttn.textContent = button.disabled ? 'Unavailable' : 'Add to bag'; }
        const url = new URL(location.href); url.searchParams.set('variant', option.value); history.replaceState({}, '', url);
      });
    });
    document.querySelectorAll('[data-live-grid]').forEach(button => {
      if (button.dataset.ready) return; button.dataset.ready = 'true';
      button.addEventListener('click', () => {
        const grid = document.getElementById('catalog-grid'); if (!grid) return;
        grid.classList.toggle('two-column', button.dataset.liveGrid === '2');
        grid.style.gridTemplateColumns = `repeat(${button.dataset.liveGrid}, minmax(0, 1fr))`;
        document.querySelectorAll('[data-live-grid]').forEach(b => b.setAttribute('aria-pressed', String(b === button)));
      });
    });
    document.querySelectorAll('[data-diamond-filter]').forEach(select => {
      if (select.dataset.ready) return; select.dataset.ready = 'true';
      const grid = document.getElementById('catalog-grid');
      if (!grid) return;
      const cards = [...grid.querySelectorAll('.catalog-card')];
      const count = document.querySelector('[data-catalog-count]');
      const empty = document.querySelector('[data-diamond-empty]');
      const apply = () => {
        const selected = select.value;
        let visible = 0;
        cards.forEach(card => {
          const show = selected === 'all' || card.dataset.diamondType === selected;
          card.hidden = !show;
          if (show) visible += 1;
        });
        if (count) count.textContent = `${visible} ${visible === 1 ? 'piece' : 'pieces'}`;
        if (empty) empty.hidden = visible !== 0;
      };
      const selectedFromUrl = new URL(location.href).searchParams.get('diamond');
      if ([...select.options].some(option => option.value === selectedFromUrl)) select.value = selectedFromUrl;
      select.addEventListener('change', apply);
      apply();
    });
  };
  setup(); document.addEventListener('shopify:section:load', setup);
})();

// Make each bridesmaid budget idea a WhatsApp enquiry with its details and image URL.
(() => {
  const prepareBridesmaidEnquiries = () => document.querySelectorAll('.gifting-budget-item').forEach(card => {
    if (card.dataset.whatsappReady) return;
    const image = card.querySelector('img');
    const name = card.querySelector('h3')?.textContent.trim();
    const description = card.querySelector('.gifting-budget-item-description')?.innerText.trim();
    const price = card.querySelector('.gifting-budget-item-price')?.textContent.trim();
    if (!image || !name) return;
    const imageUrl = new URL(image.getAttribute('src'), document.baseURI).href;
    const details = [description, price].filter(Boolean).join('\n');
    const message = `Hi Lee, I’m interested in the ${name} from your Bridesmaid Gifting page.${details ? `\n\n${details}` : ''}\n\nImage: ${imageUrl}`;
    const url = `https://wa.me/447356013844?text=${encodeURIComponent(message)}`;
    card.dataset.whatsappReady = 'true';
    card.setAttribute('role', 'link');
    card.setAttribute('tabindex', '0');
    card.setAttribute('aria-label', `Message Lee about ${name}`);
    const label = document.createElement('span');
    label.className = 'gifting-budget-enquiry-label';
    label.textContent = 'Message Lee ↗';
    card.querySelector('.gifting-budget-item-copy')?.append(label);
    const open = () => { window.location.href = url; };
    card.addEventListener('click', open);
    card.addEventListener('keydown', event => {
      if (event.key === 'Enter' || event.key === ' ') {
        event.preventDefault();
        open();
      }
    });
  });
  prepareBridesmaidEnquiries();
  document.addEventListener('shopify:section:load', prepareBridesmaidEnquiries);
})();


// Keep directional links typographic on mobile browsers that otherwise render ↗ as an emoji.
(() => {
  const normalizeArrows = root => {
    if (!root) return;
    const walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT);
    let node;
    while ((node = walker.nextNode())) {
      const tag = node.parentElement?.tagName;
      if (tag === 'SCRIPT' || tag === 'STYLE' || tag === 'NOSCRIPT' || tag === 'TEXTAREA') continue;
      if (/\u2197(?!\uFE0E)/u.test(node.nodeValue)) node.nodeValue = node.nodeValue.replace(/\u2197(?!\uFE0E)/gu, '↗︎');
    }
  };
  normalizeArrows(document.body);
  new MutationObserver(mutations => mutations.forEach(mutation => mutation.addedNodes.forEach(node => {
    if (node.nodeType === Node.TEXT_NODE) {
      if (/\u2197(?!\uFE0E)/u.test(node.nodeValue)) node.nodeValue = node.nodeValue.replace(/\u2197(?!\uFE0E)/gu, '↗︎');
    } else if (node.nodeType === Node.ELEMENT_NODE) {
      normalizeArrows(node);
    }
  }))).observe(document.body, { childList: true, subtree: true });
})();